// Module
var code = "<div class=\"h-100 w-100 flex-container-column gap-3 pb-2\">\n    <div class=\"h-100 w-100\" ref=\"typicalWeekDescription\"></div>\n    <div class=\"h-100 w-100 flex-container-row gap-1\">\n        <week-slots ref=\"weekSlots\"></week-slots>\n        <timeslots-editor ref=\"defaultTimeSlotsEditor\"></timeslots-editor>\n    </div>\n</div>";
// Exports
module.exports = code;